// Add a flag to prevent multiple simultaneous submissions
var isSubmittingHotelDetail = false;

function showHotelDetail(index){
	// Prevent multiple simultaneous calls
	if (isSubmittingHotelDetail) {
		return;
	}
	
	isSubmittingHotelDetail = true;
	
	var item = $("#hotelRowId_"+index);
	var form = $("#priceDetailHotelForm");
	
	var _channelid = $("#priceDetailHotelForm input[name=channelId]").val();
	var _providerCode = $("#priceDetailHotelForm input[name=providerCode]").val()
	var _hotelName= $("#priceDetailHotelForm input[name=hotelName]").val()
	var _id = $("#priceDetailHotelForm input[name=id]").val()
	
	var newChannelId = $(item).attr("channelId");
	var newProviderCode = $(item).attr("providerCode");
	var newHotelName = $(item).attr("hotelName");
	var newAutocompleteId = $(item).attr("autocompleteId");
	
	$("#priceDetailHotelForm input[name=channelId]").val(newChannelId);
	$("#priceDetailHotelForm input[name=providerCode]").val(newProviderCode);
	$("#priceDetailHotelForm input[name=urlHotelName]").val(newHotelName);
	$("#priceDetailHotelForm input[name=id]").val(newAutocompleteId);
	
	// Safari-specific: Add delay before form submission
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	if (isSafari) {
		setTimeout(function() {
			form[0].submit(); // Use native submit for Safari
			
			// Restore original values AFTER submission (with additional delay)
			setTimeout(function() {
				$("#priceDetailHotelForm input[name=channelId]").val(_channelid);
				$("#priceDetailHotelForm input[name=providerCode]").val(_providerCode);
				$("#priceDetailHotelForm input[name=urlHotelName]").val(_hotelName);
				$("#priceDetailHotelForm input[name=id]").val(_id);
				isSubmittingHotelDetail = false; // Reset flag
			}, 500);
		}, 100);
	} else {
		$("#priceDetailHotelForm").submit();
		
		// For non-Safari browsers, restore immediately after submission
		$("#priceDetailHotelForm input[name=channelId]").val(_channelid);
		$("#priceDetailHotelForm input[name=providerCode]").val(_providerCode);
		$("#priceDetailHotelForm input[name=urlHotelName]").val(_hotelName);
		$("#priceDetailHotelForm input[name=id]").val(_id);
		isSubmittingHotelDetail = false; // Reset flag
	}
}

var autoCompleteResult="";
var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;

var  hotelSearch = {
	searchAutoCompleteId:null,
	searchUrl:null,
	fromDate:null,
	toDate:null
};

$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

$(document).ready(function() {
	$('.loading').modal({
		show : false
	});
	
	// Initialize Lucide icons if available (for the spinner buttons)
	if (typeof lucide !== 'undefined') {
		lucide.createIcons();
	}

	$('.btn-autocomplete-from-hotel').click(function() {
		// Move input to mobile autocomplete
		$('.hotelAutoComplete').appendTo('#mobileAutocomplete .mobile-autocomplete-input');
		
		// Show mobile autocomplete
		$('#mobileAutocomplete').removeClass('d-none');
		
		// Focus and select the input
		$('.hotelAutoComplete').focus();
		$('.hotelAutoComplete').select();
		
		// Trigger autocomplete search
		$('.hotelAutoComplete').catcomplete("search", "");

	  });
  
	  // Handle close button click
	  $('#mobileAutocomplete .btn-close').click(function() {
		
		// Move inputs back to their original locations
		$('.hotelAutoComplete').appendTo('.div-autocomplete-from-hotel .input-group');
		
		// Hide mobile autocomplete
		$('#mobileAutocomplete').addClass('d-none');
	  });
	
	$(".sort-h").click(function() {
		$(this).addClass("active");
		$(".sort-v").removeClass("active");
		$(".rows").removeClass("row");
		$(".row-cols").removeClass("col-md-4");
		$(".row1,.row2").removeClass("flex-column");
		$(".row1 > div,.row2 > div").removeClass("col-md-12");
		$(".row1 > div:first-child").addClass("col-md-9");
		$(".row1 > div:last-child").addClass("col-md-3 border-start");
		$(".row1 .price").addClass("text-md-end");
		$(".row1 > div:first-child").addClass("p-4");
		$(".row2 > div:last-child").removeClass("px-4");
		$(".row2 .text-title").removeClass("h6 bold text-center");
		$(".row2 .text-body-2").removeClass("text-center");
	});
	$(".sort-v").click(function() {
		$(this).addClass("active");
		$(".sort-h").removeClass("active");
		$(".rows").addClass("row");
		$(".row-cols").addClass("col-md-4");
		$(".row1 > div,.row2 > div").addClass("col-md-12");
		$(".row1 > div:first-child").removeClass("col-md-9");
		$(".row1 > div:last-child").removeClass("col-md-3 border-start");
		$(".row1 .price").removeClass("text-md-end");
		$(".row1 > div:first-child").removeClass("p-4");
		$(".row2 > div:last-child").addClass("px-4");
		$(".row2 .text-title").addClass("h6 bold text-center");
		$(".row2 .text-body-2").addClass("text-center");
	});
	
    $('.roomSelect').val("1");
    var isHotelDetail = $("[name='hotelDetail']").val();
    if(!isHotelDetail){
        parseCookieSearchValues();
    }

	if(Hotel.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', Hotel.source, { expires : date,  path : '/' });
	}
	
	$('.hotelAutoComplete').on('change', function() {
		$('html, body').animate({scrollTop: $("header").offset().top}, 10);
	});

	$('#makeSearch').click(function(event) {
		$("#sumButton").trigger('click');
	});
	
	$('[name="hotelSearchForm"]').validate();
	
	bindDatePicker();
	
	// Update night stay display when dates change
	$(document).on('change', 'input[name="checkInDate"], input[name="checkOutDate"]', function() {
		updateNightStayCount();
	});
	
	// Initialize night stay display
	updateNightStayCount();

	// Add click handler to ensure modal opens when input is clicked
	$('#hotel-dates').on('click', function(e) {
		e.preventDefault();
		// Trigger the datepicker to show
		$(this).data('daterangepicker').show();
	});

	// Define the catcomplete widget
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu: function(ul, items) {
			var that = this;
			$.each(items, function(index, item) {
				// Only filter for cities in normal search results, not in suggested cities
				if (!isShowingSuggested && item.category !== "CITY") {
					return;
				}
				that._renderItemData(ul, item);
			});
		},
		_renderItem: function(ul, item) {
			var $li = $("<li>")
				.addClass("ui-autocomplete-item ui-menu-item hotel-autocomplete-item");

			// Add icon div
			$("<div>")
				.addClass("icon-hotel")
				.appendTo($li);

			// Create flex container
			var $flexContainer = $("<div>")
				.addClass("d-flex flex-column")
				.appendTo($li);

			// City line
			$("<div>")
				.addClass("city-name r1")
				.text(item.cityName || item.name.split(',')[0] || item.name)
				.appendTo($flexContainer);

			// Country and hotel count line
			var countryText = item.countryName || (item.name.split(',')[1] || '').trim();
			if (item.hotelCount && item.hotelCount > 0) {
				countryText += ' - ' + item.hotelCount + ' ' + FmtMessage.getMessage('js.title.hotel.name');
			}
			$("<div>")
				.addClass("hotel-country-count text-muted small")
				.text(countryText)
				.appendTo($flexContainer);

			return $li.appendTo(ul);
		}
	});

	// Suggested cities data
	const suggestedCities = [
		{ id: '31C35', city: 'Dubai', cityAr: 'دبي', country: 'UNITED ARAB EMIRATES', countryAr: 'الإمارات العربية المتحدة' },
		{ id: '3BE7', city: 'Istanbul', cityAr: 'اسطنبول', country: 'TURKEY', countryAr: 'تركيا' },
		{ id: '3226F', city: 'Cairo', cityAr: 'القاهرة', country: 'EGYPT', countryAr: 'مصر' },
		{ id: '3B0F', city: 'Beirut', cityAr: 'بيروت', country: 'LEBANON', countryAr: 'لبنان' },
		{ id: '316DE', city: 'Baghdad', cityAr: 'بغداد', country: 'IRAQ', countryAr: 'العراق' },
		{ id: '3534D', city: 'Erbil', cityAr: 'أربيل', country: 'IRAQ', countryAr: 'العراق' },
		{ id: '316F0', city: 'Amman', cityAr: 'عمان', country: 'JORDAN', countryAr: 'الأردن' },
		{ id: '31399', city: 'Doha', cityAr: 'الدوحة', country: 'QATAR', countryAr: 'قطر' }
	];

	// Function to get suggested cities
	function getSuggestedCities() {
		const locale = $.cookie('siteLocale') || 'en';
		
		return suggestedCities.map(city => {
			if (locale.startsWith('ar')) {
				return {
					value: `${city.cityAr}, ${city.countryAr}`,
					key: city.id,
					category: 'city',
					name: city.cityAr,
					cityName: city.cityAr,
					countryName: city.countryAr
				};
			} else {
				return {
					value: `${city.city}, ${city.country}`,
					key: city.id,
					category: 'city',
					name: city.city,
					cityName: city.city,
					countryName: city.country
				};
			}
		});
	}

	// Flag to track if we're showing suggested cities
	let isShowingSuggested = false;
	let isClickTriggered = false;

	$(".hotelAutoComplete").catcomplete({
		delay: 500,
		source: function(request, response) {
			// Show suggested cities if triggered by click or input is empty
			if (isClickTriggered || !request.term || request.term.length === 0) {
				isClickTriggered = false; // Reset flag
				isShowingSuggested = true; // Set flag for suggested cities
				response(getSuggestedCities());
				return;
			}

			// Show search results when user is typing (2+ characters)
			if (request.term.length >= 2) {
				isShowingSuggested = false; // Reset flag for search results
				$.ajax({
					url: "/hotel/hotels",
					dataType: "json",
					data: {
						output: 'json',
						results: 100,
						query: request.term
					},
					success: function(data) {
						if (data == null) {
							data = [];
						}
						
						var itemList = $.map(data, function(item) {
							return {
								value: item.name,
								key: item.id,
								category: item.type,
								name: item.name,
								hotelId: item.hotelId,
								hotelCount: item.hotelCount || 0
							};
						});
						
						re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
						
						var itemListNew = getHotelItemLabels(itemList);
						response(itemListNew);
					}
				});
			} else {
				// For 1 character, show empty results to hide suggestions
				isShowingSuggested = false; // Reset flag for empty results
				response([]);
			}
		},
		minLength: 0, // Changed to 0 to show suggestions immediately
		select: function(a, b) {
			document.activeElement.blur();
			if (b.item.hotelId) {
				$('[name="id"]', this.form).val(b.item.hotelId);
			}
			$('[name="id"]', this.form).val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
			
			if (!$('[name="urlHotelName"]').length) {
				$('<input>').attr({
					type: 'hidden',
					id: 'urlHotelName',
					name: 'urlHotelName'
				}).appendTo(this.form);
			}
			$('[name="urlHotelName"]').val(b.item.name);

			// Hide mobile autocomplete
			$('#mobileAutocomplete').addClass('d-none');
			$('.hotelAutoComplete').appendTo('.div-autocomplete-from-hotel .input-group');

		},
		open: function(event, ui) {
			$('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
		}
	}).change(function(event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	// Show suggested cities on input click if empty
	$(".hotelAutoComplete").on("click", function() {
		// Set flag to show suggested cities regardless of current input value
		isClickTriggered = true;
		$(this).catcomplete("search", "");
	});

	bindRoomSelector();

	$(".hotelAutoComplete").click(function() {
		$(this).select();
	});
	$('.placeholder-glow').hide();
});

function getHotelItemLabels(itemList){
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL" || category == "CATEGORY"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

// Function to update the night stay count
function updateNightStayCount() {
	// Get checkin and checkout dates
	const checkInDate = moment($('input[name="checkInDate"]').val(), 'DD.MM.YYYY');
	const checkOutDate = moment($('input[name="checkOutDate"]').val(), 'DD.MM.YYYY');
	
	// Calculate nights if both dates are valid
	if (checkInDate.isValid() && checkOutDate.isValid()) {
		// Calculate the difference in nights
		const nights = checkOutDate.diff(checkInDate, 'days');
		
		// Update the night stay display
		if (nights > 0) {
			// Update the number
			$('.nightStay').text(nights);
			
			// Show singular or plural text based on nights count
			if (nights === 1) {
				$('.nightStayText').removeClass('d-none');
				$('.nightStaysText').addClass('d-none');
			} else {
				$('.nightStayText').addClass('d-none');
				$('.nightStaysText').removeClass('d-none');
			}
		}
	}
}

function bindDatePicker() {
	// First check if hotel date element exists
	if ($('#hotel-dates').length === 0) {
		return;
	}
	
	// Get the stored dates or use today/tomorrow as defaults
	const checkInDate = $('input[name="checkInDate"]').val().length > 0 
		? moment($('input[name="checkInDate"]').val(), 'DD.MM.YYYY') 
		: moment();
	
	const checkOutDate = $('input[name="checkOutDate"]').val().length > 0 
		? moment($('input[name="checkOutDate"]').val(), 'DD.MM.YYYY') 
		: moment().add(1, 'days');
	
	// Initialize the range datepicker on the single input
	$('#hotel-dates').daterangepicker({
		minDate: moment(),
		minYear: 2024,
		maxYear: parseInt(moment().format('YYYY'),10),
		locale: {
			format: 'DD.MM.YYYY',
			firstDay: 1
		},
		startDate: checkInDate,
		endDate: checkOutDate,
		container: '#hotelDatesModal .modal-body'
	});

	$('#hotel-dates').on('show.daterangepicker', function(ev, picker) {
		$(this).data('daterangepicker').container.addClass('hoteldatepicker');
		$('.hoteldatepicker').appendTo('#hotelDatesModal .modal-body');
        
        // Show modal
        $('#hotelDatesModal').modal('show');
		
		// Add FMT labels for hotel checkin/checkout dates
		if ($('.hoteldatepicker .drp-buttons .departure-return-dates').length === 0) {
			var checkinLabel = $('<div class="departure-label"><small>' + window.checkinTitle + '</small></div>');
			var checkoutLabel = $('<div class="return-label"><small>' + window.checkoutTitle + '</small></div>');
			var containerDiv = $('<div class="departure-return-dates d-flex"></div>');
			containerDiv.append(checkinLabel);
			containerDiv.append(checkoutLabel);
			$('.hoteldatepicker .drp-buttons').prepend(containerDiv);
		}
	});
	
	// Add handler for modal close
	$('#hotelDatesModal').on('hidden.bs.modal', function () {
		// Close daterangepicker instance inside the modal
		$('#hotel-dates').data('daterangepicker')?.hide();
	});

	// Add handlers for apply and cancel buttons
	$(document).on('click', '.daterangepicker .applyBtn, .daterangepicker .cancelBtn', function() {
		$('#hotelDatesModal').modal('hide');
	});
	
	// Prevent closing daterangepicker when clicking outside the calendar
	$(document).off('mousedown.daterangepicker');
	$('#hotelDatesModal .modal-content').on('mousedown', function(e) {
		if ($(e.target).closest('.daterangepicker').length === 0) {
			e.stopPropagation();
		}
	});

	$('#hotel-dates').on('apply.daterangepicker', function(ev, picker) {
		// Update hidden inputs
		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
		
		// Update visible input with range
		$(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
		
		// Update night stay count
		updateNightStayCount();
	});
	
	// Handle the hidden dates field (if exists)
	if ($('#dates').length > 0) {
		if ($('#dates').data('daterangepicker')) {
			$('#dates').data('daterangepicker').remove();
		}
		
		$('#dates').daterangepicker({
			minDate: moment(),
			autoApply: true,
			locale: {
				format: 'DD.MM.YYYY'
			},
			startDate: checkInDate,
			endDate: checkOutDate,
			parentEl: '.hotelForm'
		});
		
		$('#dates').on('apply.daterangepicker', function(ev, picker) {
			$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
			$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
			
			// Update night stay count
			updateNightStayCount();
		});
	}
	
	// Initialize night stay count on page load
	updateNightStayCount();
}

function bindRoomSelector(context) {
	if (context == undefined)
		context = document;
	
	// Handle room count spinner
	$(".room-count-decrease", context).on('click', function() {
		var input = $(this).closest('.room-count-spinner').find('.roomSelect');
		var min = parseInt(input.data('min')) || 1;
		var currentValue = parseInt(input.val());
		
		if (currentValue > min) {
			input.val(currentValue - 1);
			// Trigger change event to update UI
			input.trigger('change');
		}
	});
	
	$(".room-count-increase", context).on('click', function() {
		var input = $(this).closest('.room-count-spinner').find('.roomSelect');
		var max = parseInt(input.data('max')) || 4;
		var currentValue = parseInt(input.val());
		
		if (currentValue < max) {
			input.val(currentValue + 1);
			// Trigger change event to update UI
			input.trigger('change');
		}
	});
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}

function parseCookieSearchValues() {
    if(($('input[type=hidden][name="overrideSearchForm"]')&&$('input[type=hidden][name="overrideSearchForm"]').val()))
        putCookieSearchValues();
	if($.cookie('hotelSearchValues') ){
		var now = new Date();
		var searchData = JSON.parse($.cookie("hotelSearchValues"));
		$('.hotelAutoComplete').data("autoCompleteResult", searchData.searchAutoCompleteId);
		
		if(!$('[name="urlHotelName"]').length ){
			$('<input>').attr({
			    type: 'hidden',
			    id: 'urlHotelName',
			    name: 'urlHotelName'
			}).appendTo(this.form);
		}
		
		$('[name="urlHotelName"]').val(searchData.searchUrl);
		if ($('[name="hotelName"]').val() == null){
			$('[name="hotelName"]').val(searchData.searchUrl);
		}
		$('[name="id"]').val(searchData.searchAutoCompleteId);
		if(searchData.fromDate !=null && searchData.fromDate.length > 0){
			var from = $.datepicker.parseDate("dd.mm.yy", searchData.fromDate);
			var formattedFromDate = searchData.fromDate;
			if(now.getTime() > from.getTime()){
				from = new Date();
				from.setDate(from.getDate() + 1);
				formattedFromDate = $.datepicker.formatDate("dd.mm.yy", from);
			}
			
			$('input[name="checkInDate"]').val(formattedFromDate);
		}
		if(searchData.toDate != null && searchData.toDate.length > 0){
			var to = $.datepicker.parseDate("dd.mm.yy", searchData.toDate);
			var formattedToDate = searchData.toDate;
			if(now.getTime() > to.getTime()){
				to = new Date();
				to.setMonth(now.getMonth(), now.getDate() + 7)
				formattedToDate = $.datepicker.formatDate("dd.mm.yy", to);
			}
			$('input[name="checkOutDate"]').val(formattedToDate);
		}
		
		// Update the visible date range input if both dates are available
		var checkInDate = $('input[name="checkInDate"]').val();
		var checkOutDate = $('input[name="checkOutDate"]').val();
		if (checkInDate && checkOutDate) {
			$('#hotel-dates').val(checkInDate + ' - ' + checkOutDate);
		}
	}
}

function putCookieSearchValues(){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	hotelSearch.searchAutoCompleteId = $('[name="id"]').val();
	hotelSearch.fromDate = $('[name="checkInDate"]').val();
	hotelSearch.toDate = $('[name="checkOutDate"]').val();
	hotelSearch.searchUrl = $('[name="urlHotelName"]').val();
	$.cookie('hotelSearchValues',  JSON.stringify(hotelSearch), { expires : date,  path : '/' });
}

function checkForSearchHotel(form) {
	var formValid = $(form).valid();
	var id = $('[name="id"]', form).val();
	
	//in case autocomplete is not selected	
	var urlHotelName = $('[name="hotelName"]').val();
	if(!id){
		$('[name="urlHotelName"]').val(urlHotelName);
	}

	if(formValid) {
		var fromDate = $("[name=checkInDate]", form).val();
		var toDate = $("[name=checkOutDate]", form).val();
		
		fromDate = $.datepicker.parseDate("dd.mm.yy", fromDate);
		toDate = $.datepicker.parseDate("dd.mm.yy", toDate);

		var day = 24*60*60*1000;
		var duration = Math.round(Math.abs((fromDate - toDate)/(day)));
		
		if(duration > 30){
			$('#hotelNotFound').modal('show');
		}else{
			var spLocationName = $(".hotelAutoComplete").val();
			$("#spLocationName").prepend(spLocationName);
			$('#hotelLoading').modal('show');
			putCookieSearchValues();
			form.submit();
		}
	}
}